import { useMemo, useState } from "react";
import type { DateFilterValue } from "../components/DateRangeFilter";
import { getDateRange } from "../utils/GetDateRange";

/**
 * Bridges DateRangeFilter to the from/to ISO strings the API expects.
 * Presets go through the existing getDateRange helper; a custom range is
 * normalised to start-of-first-day → end-of-last-day.
 */
export const useDateFilter = (initialPreset = "") => {
  const [value, setValue] = useState<DateFilterValue>({ preset: initialPreset });

  const range = useMemo(() => {
    if (value.preset === "custom" && value.from) {
      const from = new Date(value.from);
      from.setHours(0, 0, 0, 0);
      const to = new Date(value.to ?? value.from);
      to.setHours(23, 59, 59, 999);
      return { from: from.toISOString(), to: to.toISOString() };
    }

    const { current } = getDateRange(value.preset);
    return { from: current.from ?? "", to: current.to ?? "" };
  }, [value]);

  return { value, setValue, range };
};
